export const DOWNLOAD_DESIGN_REQUEST = "APP/ENTITIES/DOWNLOADS/REQUEST";
export const DOWNLOAD_DESIGN_REQUEST_SUCCESS =
  "APP/ENTITIES/DOWNLOADS/REQUEST_SUCCESS";
export const DOWNLOAD_DESIGN_REQUEST_FAILURE =
  "APP/ENTITIES/DOWNLOADS/REQUEST_FAILURE";
